"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";

import { PhoneIcon, MessageCircleIcon } from "./Icons";

const navLinks = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/courses", label: "Courses" },
  { href: "/universities", label: "Universities" },
  { href: "/contact", label: "Contact" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    setMobileOpen(false);
  }, [pathname]);

  return (
    <>
      <header className="header" id="main-header">
        <div className="header-container">
          <Link href="/" className="header-logo" id="header-logo">
            <div className="header-logo-img-wrap">
              <Image
                src="/future_logo.png"
                alt="Future Institute Logo"
                width={250}
                height={120}
                style={{ objectFit: "contain", width: "auto", height: "100%" }}
                preload={true}
              />
            </div>
          </Link>

          <nav className="header-nav" id="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className={pathname === link.href ? "active" : ""}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://wa.me/917902222553?text=Hi%20Future%20Institute%2C%20I%20am%20interested%20in%20distance%20education%20courses."
              target="_blank"
              rel="noopener noreferrer"
              className="header-cta"
              id="header-whatsapp-cta"
              style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem" }}
            >
              <PhoneIcon size={14} style={{ strokeWidth: 3 }} /> Enquire Now
            </a>
          </nav>

          <button
            className={`mobile-toggle ${mobileOpen ? "open" : ""}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle mobile menu"
            id="mobile-menu-toggle"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`mobile-overlay ${mobileOpen ? "open" : ""}`}
        onClick={() => setMobileOpen(false)}
      />
      <nav className={`mobile-menu ${mobileOpen ? "open" : ""}`} id="mobile-nav">
        <div style={{ marginBottom: "2rem", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Image
            src="/future_logo.png"
            alt="Future Institute Logo"
            width={150}
            height={60}
            style={{ objectFit: "contain", width: "auto", height: "100%", maxHeight: "50px" }}
          />
          <button 
            onClick={() => setMobileOpen(false)}
            style={{ background: "none", border: "none", cursor: "pointer", padding: "0.5rem", color: "#0A1628" }}
            aria-label="Close menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        {navLinks.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            className={pathname === link.href ? "active" : ""}
          >
            {link.label}
          </Link>
        ))}
        <a
          href="https://wa.me/917902222553?text=Hi%20Future%20Institute%2C%20I%20am%20interested%20in%20distance%20education%20courses."
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            marginTop: "1rem",
            padding: "0.75rem 1.5rem",
            background: "#8B1A1A",
            color: "white",
            borderRadius: "50px",
            fontWeight: 600,
          }}
        >
          <MessageCircleIcon size={16} style={{ strokeWidth: 3 }} /> WhatsApp Us
        </a>
      </nav>
    </>
  );
}
